/* pdp-notify.js — the notify-me morph for PDPs that do not run product-hero.js.
   Added 2026-10-06 for the resin hero (sections/product-hero-r45.liquid), whose
   sold-out state was a dead button: the Klaviyo back-in-stock flow (BIS r6,
   RTZusq) took zero sign-ups from 12 Sep while Hojari Blend was out.

   A port of the "NOTIFY ME - IN-PLACE MORPH" block in assets/product-hero.js,
   not a new design. The two writes are the old hero's, unchanged:
     1. the Klaviyo back-in-stock subscription: same endpoint, company id
        (VFiMuh, as in assets/ss-klaviyo.js), revision header and JSON:API
        body, variant as $shopify:::$default:::<variant id>;
     2. the Shopify customer record through the Liquid-rendered customer form
        (contact[tags] back-in-stock, contact[note] product - size), plus
        SSKlv.identify for browse-abandonment.
   Like the old hero, the subscription is NOT behind ss-klaviyo.js's
   internalVisit() gate: typing an email into "notify me" is the request
   itself, and it is how a post-deploy check with ss_internal=1 can see it.

   The markup contract (one per page):
     [data-pdp-notify]           the .notify-morph; data-form names the customer
                                 form, data-str-{invalid,failed,done} the copy
     [data-notify-host]          its wrapper; data-notify-{product,variant,
                                 variant-id} is the default context
     [data-notify-size]          optional, inside the host: "<size> · " label
     [data-notify-open]          any trigger elsewhere (a sticky bar, a sold-out
                                 size); its own data-notify-* wins over the host
   Nothing here touches the money path (assets/pdp-atc.js). */
(function () {
  var morph = document.querySelector('[data-pdp-notify]');
  if (!morph) return;
  var host = morph.closest('[data-notify-host]');
  var form = document.getElementById(morph.getAttribute('data-form') || '');
  var trigger = morph.querySelector('.notify-morph__trigger');
  var input = morph.querySelector('.notify-morph__input');
  var note = morph.querySelector('[name="contact[note]"]');
  var tags = morph.querySelector('[name="contact[tags]"]');
  var sendBtn = morph.querySelector('.notify-morph__send');
  var msg = morph.querySelector('.notify-morph__msg');
  var strings = {
    invalid: morph.getAttribute('data-str-invalid') || 'Please check the email address.',
    failed: morph.getAttribute('data-str-failed') || "That didn't send. Try again.",
    done: morph.getAttribute('data-str-done') || ''
  };

  var variantId = '';
  var lastTrigger = null;
  /* Whether the host was hidden when the current open began: a sold-out SIZE
     line opens a host that is hidden while the page still sells, and closing
     it must put it back. Read at open time, because product-hero-r45.js also
     shows and hides the host as availability changes. */
  var hostWasHidden = false;
  /* The done state belongs to the variant actually subscribed this page load
     and stands until a different one is asked for. No timer. */
  var subscribedVariantId = '';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function state() { return morph.dataset.state || 'idle'; }
  function setState(s) {
    morph.dataset.state = s;
    if (trigger) trigger.setAttribute('aria-expanded', s === 'open' || s === 'sending' ? 'true' : 'false');
  }
  /* One live region for both outcomes: the error is shown, the confirmation
     only announced (the visible confirmation is the morph itself). */
  function message(text, srOnly) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('notify-morph__msg--sr', !!srOnly);
  }

  /* A page that renders in stock leaves the morph's sold-out words empty, the
     text parked in data-fill-label, so a crawler does not read "Sold out" on a
     page that sells. Every way of showing the host comes through here. */
  function fillLabels() {
    var els = (host || morph).querySelectorAll('[data-fill-label]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].textContent) els[i].textContent = els[i].getAttribute('data-fill-label');
    }
  }

  function applyContext(el) {
    fillLabels();
    var source = (el && el.dataset && el.dataset.notifyProduct) ? el : host;
    if (!source || !source.dataset.notifyProduct) return;
    var variantName = source.dataset.notifyVariant || '';
    var productName = source.dataset.notifyProduct || '';
    variantId = source.dataset.notifyVariantId || (host && host.dataset.notifyVariantId) || '';
    var distinct = variantName && variantName !== productName;
    if (note) note.value = distinct ? 'Back in Stock: ' + productName + ' - ' + variantName : 'Back in Stock: ' + productName;
    var productTag = productName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    if (tags) tags.value = 'back-in-stock, notify, notify-' + productTag;
    var sizeEl = host && host.querySelector('[data-notify-size]');
    if (sizeEl) sizeEl.textContent = distinct ? variantName + ' · ' : '';
    /* Re-arm only for a different variant; the same one keeps its confirmation. */
    if (state() === 'done' && variantId && variantId !== subscribedVariantId) {
      message('');
      setState('idle');
    }
  }

  function open(el, scroll) {
    lastTrigger = el || lastTrigger;
    applyContext(el);
    if (host && host.hasAttribute('hidden')) {
      hostWasHidden = true;
      host.removeAttribute('hidden');
    } else if (state() !== 'open') {
      hostWasHidden = false;
    }
    if (state() === 'done') {
      if (scroll) scrollTo();
      return;
    }
    message('');
    if (input) input.removeAttribute('aria-invalid');
    setState('open');
    /* Flush styles first: the field is visibility:hidden until the state lands
       and focus() on a hidden element is a no-op. Same task as the tap, so iOS
       raises the keyboard. */
    void morph.offsetWidth;
    if (input) {
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }
    if (scroll) scrollTo();
  }
  function scrollTo() {
    try { morph.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' }); }
    catch (e) { morph.scrollIntoView(); }
  }

  function collapse(returnFocus) {
    if (state() !== 'open') return;
    message('');
    setState('idle');
    if (hostWasHidden && host) host.setAttribute('hidden', '');
    if (returnFocus) {
      var back = (hostWasHidden && lastTrigger) ? lastTrigger : trigger;
      if (back) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    }
    hostWasHidden = false;
  }

  if (trigger) trigger.addEventListener('click', function (e) { e.stopPropagation(); open(this, false); });
  [].forEach.call(document.querySelectorAll('[data-notify-open]'), function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      /* These sit away from the morph, so bring it into view as it opens. */
      open(this, true);
    });
  });

  morph.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); collapse(true); }
  });
  document.addEventListener('click', function (e) {
    if (state() !== 'open') return;
    if (morph.contains(e.target)) return;
    /* A half-typed address is work already done; a stray tap keeps it. */
    if (input && input.value.trim()) return;
    collapse(false);
  });

  if (form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      send();
    });
  }
  if (sendBtn) {
    sendBtn.setAttribute('type', 'button');
    sendBtn.addEventListener('click', function () { send(); });
  }
  if (input) input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); send(); }
  });
  /* A correction clears the complaint; it does not wait for the next send. */
  if (input) input.addEventListener('input', function () {
    if (input.getAttribute('aria-invalid') !== 'true') return;
    input.removeAttribute('aria-invalid');
    message('');
  });

  function showDone() {
    setState('done');
    message(strings.done, true);
    if (form) form.reset();
    subscribedVariantId = variantId || subscribedVariantId;
    hostWasHidden = false;
  }
  function showFailed() {
    setState('open');
    message(strings.failed);
    if (input) input.focus();
  }

  function send() {
    if (state() === 'sending') return;
    var email = input ? input.value.trim() : '';
    if (!email || (input.checkValidity && !input.checkValidity())) {
      message(strings.invalid);
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return;
    }
    input.removeAttribute('aria-invalid');
    message('');
    setState('sending');

    /* 1 · Klaviyo back-in-stock — byte for byte the old hero's request
       (assets/product-hero.js, notifySend). keepalive so nothing below can
       abort it mid-flight. */
    var klaviyo = Promise.resolve(false);
    if (variantId) {
      klaviyo = fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VFiMuh', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email.toLowerCase() } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      }).then(function (resp) {
        if (!resp.ok && window.console) console.warn('Klaviyo back-in-stock subscribe failed', resp.status);
        return resp.ok;
      }).catch(function (err) {
        if (window.console) console.warn('Klaviyo back-in-stock subscribe error', err);
        return false;
      });
    }
    if (window.SSKlv && typeof window.SSKlv.identify === 'function') window.SSKlv.identify(email);

    /* 2 · The Shopify customer record. This store answers a scripted /contact
       POST with a captcha challenge, so the old hero lets that duplicate record
       go rather than unload the page, and Klaviyo's own answer decides between
       the confirmation and the inline retry. Same here. */
    var settleOnKlaviyo = function () {
      klaviyo.then(function (ok) { if (ok) showDone(); else showFailed(); });
    };
    if (!form) { settleOnKlaviyo(); return; }
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new URLSearchParams(new FormData(form))
    }).then(function (resp) {
      if (resp.ok && resp.url.indexOf('/challenge') === -1) showDone();
      else settleOnKlaviyo();
    }).catch(settleOnKlaviyo);
  }

  /* For section scripts that change the subscribed variant without a click
     (product-hero-r45.js, when the chosen size sells out mid-visit). */
  window.SSPdpNotify = { context: applyContext };
})();
